module.exports = __webpack_public_path__ + "img/settings.11822686.svg";